import React from 'react';

import TextField from '@material-ui/core/TextField';

const SubInput = ({ formik, disabled, name, label, required = false, placeholder, helperText, showInfo = false }) => {
  return (
    <div className="ui-card-item">
      <TextField
        name={name}
        label={label}
        disabled={disabled}
        type={'text'}
        style={{ width: '100%' }}
        required={required}
        color="primary"
        placeholder={placeholder}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values[name] || ''}
        error={formik.touched[name] && formik.errors[name]}
        helperText={showInfo && helperText}
      />
      {formik.touched[name] && formik.errors[name] && <p className={'customErrorMsg'}>{formik.errors[name]}</p>}
    </div>
  );
};

export default SubInput;
